import {Component, Input} from "@angular/core";
import {AvdbPricingProduct} from "../database-pricing/avdb-pricing-product";
import {AvdbPricingProductSeries} from "../database-pricing/avdb-pricing-product-series";
import {cdnURL} from "site";

@Component({
	selector: "coverage-detail-panel",
	template: `
		<div>
			<a class="coveragedetail_expandlink" (click)="showPanel = !showPanel">
				<i [class]="(showPanel) ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
				{{(showPanel) ? "Hide Details" : "Show Details"}}
			</a>
		</div>

		<ng-container *ngIf="showPanel && coverageSeries.region">
			<div class="coveragedetail_panel">
				<ng-container *ngIf="coverageSeries.coverageDurationOptions !== null && coverageProduct !== null">
					<p class="coveragedetail_productdetails">Part number: {{coverageProduct.partKey}}</p>
				</ng-container>
				<ng-container *ngFor="let message of coverageSeries.messages">
					<avdb-message [message]="message"></avdb-message>
				</ng-container>
				<image-container [width]="310" [height]="240" [src]="coverageMapPath + coverageSeries.region.coverageMapFilename" [alt]="'Coverage Map'"></image-container>
				<div class="coveragedetail_coveragetext" [innerHtml]="coverageSeries.region.coverageDescriptionHTML"></div>
			</div>
		</ng-container>
	`,
})
export class CoverageDetailPanelComponent {
	showPanel = false;

	@Input()
	coverageSeries: AvdbPricingProductSeries = null;
	@Input()
	coverageProduct: AvdbPricingProduct = null;
	@Input()
	coverageMapPath = cdnURL + "/img/avdb_type_regions/";

	get iconClass() {
		return this.showPanel ? "fa-chevron-up" : "fa-chevron-down";
	}
}
